/**
 * Post-processing module exports.
 *
 * This module provides a unified post-processing system that works with both
 * WebGL and WebGPU renderers.
 */

// Core interfaces and base class
export { IPostProcessEffect } from './IPostProcessEffect.js';
export type { BaseEffectConfig, EffectContext, WebGLEffectData, WebGPUEffectNode, WebGPUComposeContext } from './IPostProcessEffect.js';
export { PostProcessPass as PostProcessEffectType, PostProcessRenderOrder } from './PostProcessConfig.js';

export type { IPostProcessPipeline, PipelineHooks } from './IPostProcessPipeline.js';

// Configuration types
export * from './PostProcessConfig.js';

// Pipelines
export { WebGLPipeline } from './pipelines/WebGLPipeline.js';
export { WebGPUPipeline } from './pipelines/WebGPUPipeline.js';

// Built-in effects
export * from './effects/index.js';

// Utilities
export { EffectPassWrapper } from './utils/EffectPassWrapper.js';
